import { Orb } from "./Orb";
import { MicButton } from "./MicButton";
import { useJarvis } from "../hooks/useJarvis";
import type { JarvisSettings } from "../hooks/useSettings";

interface MainScreenProps {
  settings: JarvisSettings;
  onOpenSettings: () => void;
}

function formatSeconds(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function MainScreen({ settings, onOpenSettings }: MainScreenProps) {
  const jarvis = useJarvis(settings);

  return (
    <div className="screen main-screen">
      <span className="hud-corner tl" aria-hidden="true" />
      <span className="hud-corner tr" aria-hidden="true" />
      <span className="hud-corner bl" aria-hidden="true" />
      <span className="hud-corner br" aria-hidden="true" />

      <div className="top-bar">
        <div className="brand">J.A.R.V.I.S</div>
        <button
          className="settings-button"
          type="button"
          aria-label="Nastavenia"
          onClick={onOpenSettings}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <div className="orb-stage">
        <Orb state={jarvis.state} />
      </div>

      <div className="status-readout">
        <div className="status-label">Stav systému</div>
        <div className={`status-text state-${jarvis.state}`}>
          {jarvis.state === "error" && jarvis.errorDetail ? jarvis.errorDetail : jarvis.statusText}
        </div>
      </div>

      {jarvis.state === "listening" && (
        <div className="recording-time">{formatSeconds(jarvis.recordingSeconds)}</div>
      )}

      <div className="controls">
        <button
          type="button"
          className={`handsfree-toggle ${jarvis.handsFreeEnabled ? "on" : ""}`}
          onClick={() => void jarvis.toggleHandsFree()}
          disabled={jarvis.state === "thinking"}
        >
          Hands-free: {jarvis.handsFreeEnabled ? "zapnuté" : "vypnuté"}
        </button>

        <MicButton state={jarvis.state} onPress={jarvis.toggleListening} />
        {jarvis.state === "listening" && (
          <button className="cancel-link" type="button" onClick={jarvis.cancelListening}>
            Zrušiť
          </button>
        )}
      </div>
    </div>
  );
}

